import { workspace_CustomList } from "../../Apis/user/ApiConfig";
import {
  WORKSPACES_CUSTOM_LIST_SUCCESS,
  WORKSPACES_CUSTOM_LIST_ERROR,
  WORKSPACES_CUSTOM_LIST_REQUEST,
} from "../../Types/user/Types";

export const workspaces_Custom_List_Success = (res) => {
  return {
    type: WORKSPACES_CUSTOM_LIST_SUCCESS,
    payload: res,
  };
};
export const workspaces_Custom_List_Error = (error) => {
  return {
    type: WORKSPACES_CUSTOM_LIST_ERROR,
    error: error,
  };
};

export const workspaces_Custome_List_Request = (res) => {
  return {
    type: WORKSPACES_CUSTOM_LIST_REQUEST,
    payload: res,
  };
};

export const workspaces_Custome_List_ActionHandler = () => {
  return (dispatch) => {
    try {
      workspace_CustomList()
        .then((res) => {
          if (res) {
            if (res && res?.data && res?.status === 200) {
              dispatch(workspaces_Custom_List_Success(res?.data));
            } else {
              dispatch(workspaces_Custom_List_Error(res));
            }
          } else {
            dispatch(workspaces_Custom_List_Error(""));
          }
        })
        .catch((err) => {
          dispatch(workspaces_Custom_List_Error("Something Went Wrong!!!"));
        });
    } catch (err) {
      dispatch(workspaces_Custom_List_Error(err));
    }
  };
};